import React from 'react'

import useTranslations from '../../../hooks/useTranslations'
import ANTDTable from '../../../shared/antd/ANTDTable'
import { length } from '../../../utils/javascript'

const EngineModifications = () => {
  const { t } = useTranslations()

  const dataSource = [
    {
      key: '1',
      date: '2021-01-15',
      errorCode: 'P0300',
      errorDescription: 'inv_RepairInstruction3',
      resolution: 'inv_AutomobileIssueResolution1',
      serviceCenterName: 'ABC Auto Repair',
      engineDppUpdated: 'Yes',
      dppOfPartExtracted: 'N/A',
      dppOfPartInserted: 'N/A',
    },
    {
      key: '2',
      date: '2021-05-10',
      errorCode: 'P0420',
      errorDescription: 'inv_AutomobileIssueDescription2',
      resolution: 'inv_AutomobileIssueResolution3',
      serviceCenterName: 'XYZ Exhaust Specialists',
      engineDppUpdated: 'Yes',
      dppOfPartExtracted: '6p165e4d-30jk-5678',
      dppOfPartInserted: '6p165e4d-30jk-2345',
    },
    {
      key: '3',
      date: '2021-09-20',
      errorCode: 'P0171',
      errorDescription: 'inv_AutomobileIssueDescription4',
      resolution: 'inv_AutomobileIssueResolution5',
      serviceCenterName: 'DEF Engine Diagnostics',
      engineDppUpdated: 'Yes',
      dppOfPartExtracted: 'N/A',
      dppOfPartInserted: 'N/A',
    },
    {
      key: '4',
      date: '2022-03-05',
      errorCode: 'P0128',
      errorDescription: 'inv_PartIssueDescription4',
      resolution: 'inv_PartResolution4',
      serviceCenterName: 'GHI Auto Service',
      engineDppUpdated: 'Yes',
      dppOfPartExtracted: '9p165e4d-30jk-1122',
      dppOfPartInserted: '6p165e4d-30jk-4567',
    },
    {
      key: '5',
      date: '2022-07-15',
      errorCode: 'P0100',
      errorDescription: 'inv_RepairInstruction1',
      resolution: 'inv_PartResolution5',
      serviceCenterName: 'JKL Automotive Solutions',
      engineDppUpdated: 'Yes',
      dppOfPartExtracted: '1p165e4d-30jk-8910',
      dppOfPartInserted: '6p165e4d-30jk-6789',
    },
    // {
    //   key: '6',
    //   date: '2022-11-12',
    //   errorCode: 'P0130',
    //   errorDescription: 'Oxygen Sensor Circuit Malfunction (Bank 1)',
    //   resolution: 'Replaced oxygen sensor.',
    //   serviceCenterName: 'MNO Car Care',
    //   engineDppUpdated: 'Yes',
    //   dppOfPartExtracted: '4p165e4d-30jk-3456',
    //   dppOfPartInserted: '6p165e4d-30jk-7890',
    // },
    // {
    //   key: '7',
    //   date: '2023-02-18',
    //   errorCode: 'P0200',
    //   errorDescription: 'Injector Circuit Malfunction',
    //   resolution: 'Repaired wiring and replaced faulty injector.',
    //   serviceCenterName: 'PQR Fuel Injection Services',
    //   engineDppUpdated: 'Yes',
    //   dppOfPartExtracted: 'N/A',
    //   dppOfPartInserted: 'N/A',
    // },
    // {
    //   key: '8',
    //   date: '2023-06-25',
    //   errorCode: 'P0455',
    //   errorDescription: 'Evaporative Emission Control System Leak Detected',
    //   resolution: 'Replaced gas cap and repaired EVAP hoses.',
    //   serviceCenterName: 'STU Emissions Specialists',
    //   engineDppUpdated: 'Yes',
    //   dppOfPartExtracted: 'N/A',
    //   dppOfPartInserted: 'N/A',
    // },
    // {
    //   key: '9',
    //   date: '2023-09-30',
    //   errorCode: 'P0500',
    //   errorDescription: 'Vehicle Speed Sensor Malfunction',
    //   resolution: 'Replaced vehicle speed sensor.',
    //   serviceCenterName: 'VWX Auto Repair',
    //   engineDppUpdated: 'Yes',
    //   dppOfPartExtracted: 'N/A',
    //   dppOfPartInserted: 'N/A',
    // },
  ]

  const columns = [
    {
      title: t('job_Date'),
      dataIndex: 'date',
      key: 'date',
    },
    {
      title: t('job_ErrorCode'),
      dataIndex: 'errorCode',
      key: 'errorCode',
    },
    {
      title: t('job_ErrorDescription'),
      dataIndex: 'errorDescription',
      key: 'errorDescription',
      render: rowData => t(rowData),
    },
    {
      title: t('inv_Resolution'),
      dataIndex: 'resolution',
      key: 'resolution',
      render: rowData => t(rowData),
    },
    {
      title: t('inv_ServiceCenterName'),
      dataIndex: 'serviceCenterName',
      key: 'serviceCenterName',
    },
    {
      title: t('inv_DPPUpdated'),
      dataIndex: 'engineDppUpdated',
      key: 'engineDppUpdated',
    },
    {
      title: t('inv_DPPOfPartExtracted'),
      dataIndex: 'dppOfPartExtracted',
      key: 'dppOfPartExtracted',
    },
    {
      title: t('inv_DPPOfPartInserted'),
      dataIndex: 'dppOfPartInserted',
      key: 'dppOfPartInserted',
    },
  ]

  return (
    <ANTDTable
      dataSource={dataSource}
      columns={columns}
      // pagination={false}
      scroll={{ x: 600 }}
      pagination={{
        pageSize: 5,
        total: length(dataSource) || 0,
      }}
      // loading={loader}
    />
  )
}

export default EngineModifications
